import React from "react";
import { connect } from "react-redux";
import { browserHistory } from "react-router";
import find from "lodash.find";
import user from "ducks/user";
import UserService from "services/User";
import appPath from "utils/appPath";
import manageSubscriptionActions from "ducks/manageSubscription";
import ManageBulkSubscriptionContainer from "./ManageBulkSubscriptionContainer";
import { SUBSCRIPTION_TYPE } from "common/constants/v2/Constants";
import { SCREENS } from "common/constants/Constants";
import { setThinking, doneThinking } from "ducks/thinking";

class ManageSubscriptionContainer extends React.Component {
    componentDidMount() {
        this.props.init();
    }

    render() {
        const {
            subscription = {},
            thinking
        } = this.props;

        if (thinking) {
            return null;
        }

        if (subscription.type === SUBSCRIPTION_TYPE.BULK) {
            return <ManageBulkSubscriptionContainer />;
        }

        return null;
    }
}

export function mapStateToProps(state) {
    const {
        manageSubscription = {},
        entitlements,
        thinking
    } = state;

    const subscription = find(entitlements.subscriptions, (sub) => {
        return sub.id === manageSubscription.id;
    });

    return {
        subscription,
        thinking
    };
}

export function mapDispatchToProps(dispatch, ownProps) {
    return {
        init() {
            dispatch(setThinking());
            dispatch(checkUser())
                .then(() => dispatch(manageSubscriptionActions.getSubscription(ownProps.location.query.id)))
                .then(() => dispatch(doneThinking()))
                .catch(() => dispatch(doneThinking()));
        }
    };
}

function checkUser() {
    return (dispatch) => {
        if (UserService.hasUserToken()) {
            return dispatch(user.startFetchingUser())
                .catch((error) => {
                    if (error.status === 401) {
                        browserHistory.push(appPath.withoutQuery(SCREENS.SIGN_IN));
                    }
                });
        }

        browserHistory.push(appPath.withoutQuery(SCREENS.SIGN_IN));

        return Promise.reject();
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ManageSubscriptionContainer);
